import React from 'react';

import './Chef.css';

import { SubHeading } from '../../components';
import { images } from '../../constants';

const Chef = () => (
  <div className="app__bg app__wrapper section__padding">
    <div className="app__wrapper_img app_wrapper_img-reverse">
      <img src={images.chef} alt="chef" />
    </div>

    <div className="app__wrapper_info">
      <SubHeading title="Chef's Word" />
      <h1 className='headtext__cormorant'>What we believe in</h1>

      <div className="app__chef-content">
        <div className="app__chef-content_quote">
          <img src={images.quote} alt="quote" />

          <p className='p__opensans'>
            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Officiis provident incidunt rerum quo neque, dicta nobis molestias consequuntur? Deserunt voluptatum numquam exercitationem ipsam molestias ad sunt officia neque cum itaque?
          </p>
        </div>

        <p className='p__opensans'>
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Non illo aut odit ipsa suscipit provident dolore maxime est soluta, impedit quas ea ut dolorum! Perferendis a dicta recusandae corrupti esse!
        </p>
      </div>

      <div className="app__chef-sign">
        <p>Kevin Luo</p>

        <p className='p__opensans'>
          Chef and Founder
        </p>

        <img src={images.sign} alt="sign" />

      </div>

    </div>

  </div>
);

export default Chef;
